export type InvestmentsAccessResponse = {
  authenticated: boolean;
  authorized: boolean;
  isGod: boolean;
  reason: "unauthenticated" | "not_allowlisted" | "session_invalid" | "ok" | "";
  canUseFmp: boolean;
  fmpReason: "unauthenticated" | "not_allowlisted" | "session_invalid" | "ok" | "";
  user?: {
    email: string;
    name: string;
  };
};

export type CurrentUserResponse = {
  authenticated: boolean;
  reauth?: boolean;
  user?: {
    id: number;
    name: string;
    email: string;
    picture?: string;
    admin_level: number;
  };
};

export async function fetchInvestmentsAccess(): Promise<InvestmentsAccessResponse> {
  const response = await fetch("/api/auth/access/investments", {
    credentials: "include",
  });
  if (!response.ok) {
    throw new Error(`Failed to check investments access: ${response.status}`);
  }
  return response.json() as Promise<InvestmentsAccessResponse>;
}

export async function fetchCurrentUser(): Promise<CurrentUserResponse> {
  const response = await fetch("/api/me", {
    credentials: "include",
  });
  if (response.status === 401) {
    return response.json() as Promise<CurrentUserResponse>;
  }
  if (!response.ok) {
    throw new Error(`Failed to load current user: ${response.status}`);
  }
  return response.json() as Promise<CurrentUserResponse>;
}
